import React, { useEffect, useState } from "react";
import { X } from "lucide-react";
import { OpenTextGet } from "../../server/OpenText";

const PopUp = ({ close, width, children, wrapperClassName }) => {
  useEffect(() => {
    document.body.classList.add("modal-open");
    return () => {
      document.body.classList.remove("modal-open");
    };
  }, []);

  const wrapperClass = ["popup-wrapper", "animated", wrapperClassName]
    .filter(Boolean)
    .join(" ");

  const wrapperStyle =
    width !== undefined && width !== null && width !== ""
      ? { width }
      : undefined;

  return (
    <div className="popup">
      <div className={wrapperClass} style={wrapperStyle}>
        {close && (
          <button
            type="button"
            onClick={close}
            className="close-popup"
            aria-label="סגור"
          >
            <X className="close-popup__icon" size={28} strokeWidth={2} />
          </button>
        )}
        <div className="children-popup">{children}</div>
      </div>
    </div>
  );
};

export default PopUp;

export const SystemMessagePopUp = ({ close, width, children }) => {
  const [isMassage, setIsMassage] = useState(false);
  const KIND = "loginMessage";

  useEffect(() => {
    OpenTextGet(KIND)
      .then((x) => setIsMassage(x.data.length > 0 ? true : false))
      .catch((e) => console.log("error", e));
  }, []);

  if (!isMassage) return null;

  return (
    <PopUp
      close={close}
      width={width}
      wrapperClassName="popup-wrapper--system-message"
    >
      {children}
    </PopUp>
  );
};
